import React from 'react'
import PropTypes from 'prop-types'
import {withStyles} from 'material-ui/styles/index'
import withWidth from 'material-ui/utils/withWidth'
import compose from 'recompose/compose'
import Typography from 'material-ui/Typography'
import {Button} from '../../../components'

import {yours as text} from '../text'
import styles from '../styles'
import Container from '../../../common/components/Container'
import ObjectList from '../../../common/components/ObjectList'
import HeaderProgress from '../../../common/components/HeaderProgress'
// import Title from './title'
// import CategoryList from '../containers/categoryList'
import NoObjects from './NoObjects'
import Share from '../../shared/containers/share'
import MissingInfo from '../../missingInfo/containers/missingInfo'
import InfiniteScroll from '../../../common/components/InfiniteScroll'
import Costs from '../containers/costs'
import {PRICES_AVAILABLE} from '../../../App'

const ENABLE_INFINITE_SCROLL = false

class Yours extends React.Component {

  state = {
    isOpen: false,
  }

  tileClick = id => {
    this.props.history.push('/objetos/' + id + '/edit')
  }

  handleLoginClick = () => {
    this.props.openLogin()
  }

  handleStoreClick = () => {
    this.setState({
      isOpen: true,
    })
  }

  loadMore = () => {
    const amount = 8
    this.props.setOffset(this.props.offset + amount)
    this.props.setLimit(amount)
    this.props.search()
  }

  renderNotLoggedInMessage = ({classes, openCosts, startDeposit}) => (
    <div className={classes.messageWrapper}>
      <img
        src={'/assets/noItems.png'} alt={'no items'}
        width={100} height={100} style={{objectFit: 'scale-down', marginBottom: 25}}
      />
      <Typography variant={'headline'} align={'center'} gutterBottom={true}>{text.notLoggedInMessage.title}</Typography>
      <Typography variant="body1" gutterBottom align={'center'} className={classes.messageBody}>
        {text.notLoggedInMessage.body}
      </Typography>
      <div className={classes.buttonWrapper}>
        {PRICES_AVAILABLE && <Button variant="secondary" fullWidth={true} style={{marginBottom: 10}} onClick={() => openCosts()}>{text.notLoggedInMessage.costsButton}</Button>}
        <Button variant="primary" fullWidth={true} onClick={startDeposit}>{text.notLoggedInMessage.signupButton}</Button>
      </div>

      <Costs/>
    </div>
  )

  render() {
    const {classes, isLoggedIn, items, width, isSearching, isDirty, startDeposit, expectMore, openCosts} = this.props
    if (isLoggedIn === false)
      return this.renderNotLoggedInMessage(this.props)
    if (isDirty === false && isSearching === false && items.length === 0)
      return <NoObjects startDeposit={startDeposit} firstLoginProps={{isOpen: this.state.isOpen}} openCosts={openCosts}/>

    const shouldTriggerInfiniteScroll = ENABLE_INFINITE_SCROLL === true && isSearching === false && expectMore === true

    return (
      <Container>
        <InfiniteScroll shouldTrigger={shouldTriggerInfiniteScroll} trigger={this.loadMore}>
          <HeaderProgress show={isSearching}/>
          <Share/>
          <MissingInfo/>
          {/*<Title gutterBottom={true}>Categorías</Title>*/}
          {/*<CategoryList/>*/}
          {/*<Title gutterBottom={true}>Mi Catálogo</Title>*/}
          {
            isSearching === true && items.length === 0 ? null : (
              <div className={classes.buttonContainer}>
                <Button
                  type="submit"
                  variant={'secondary'}
                  className={classes.button}
                  onClick={() => startDeposit()}
                >
                  {text.depositButton}
                </Button>
                {/*<Button*/}
                {/*type="submit"*/}
                {/*className={classes.button}*/}
                {/*onClick={() => setOpenShare(true)}*/}
                {/*>*/}
                {/*{text.shareButton}*/}
                {/*</Button>*/}
              </div>
            )
          }
          <ObjectList
            items={items}
            width={width}
            handleTileClick={this.tileClick}
            showNoObjectsMessage={items.length === 0 && isSearching === false}
            showAction={this.props.isRemoveActive}
            handleActionClick={this.props.addItem}
          />
          {expectMore === true && isSearching === false ? (
            <div style={{marginTop: 25, textAlign: 'center'}}>
              <Button variant={'primary'} onClick={this.loadMore}>{text.loadMore}</Button>
            </div>
          ) : null}
        </InfiniteScroll>
      </Container>
    )
  }
}

Yours.propTypes = {
  isRemoveActive: PropTypes.bool.isRequired,
  isLoggedIn: PropTypes.bool.isRequired,
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
  isSearching: PropTypes.bool.isRequired,
  isDirty: PropTypes.bool.isRequired,
  setOpenShare: PropTypes.func.isRequired,
  startDeposit: PropTypes.func.isRequired,
  setOffset: PropTypes.func.isRequired,
  setLimit: PropTypes.func.isRequired,
  search: PropTypes.func.isRequired,
  expectMore: PropTypes.bool,
  openLogin: PropTypes.func.isRequired,
  addItem: PropTypes.func.isRequired,
  openCosts: PropTypes.func.isRequired,
}

export default compose(withStyles(styles, {withTheme: true}), withWidth())(Yours)



// WEBPACK FOOTER //
// ./src/sections/yours/components/Yours.js